import { Button, Grid, Typography } from "@mui/material";
import { LoadingButton } from "src/grading/components";
import RFModal from "src/grading/components/RFModal/RFModal";
import theme from "src/theme";
import useStyles from "./ConfirmationModal.styles";

interface ConfirmationModalProps {
  onClose: () => void;
  open: boolean;
  isLoading?: boolean;
  onConfirm: () => void;
  title: string;
  message: string;
  confirmationButtonTitle: string;
  type?: "success" | "error";
}

const ConfirmationModal = ({
  onClose,
  open,
  isLoading,
  onConfirm,
  title,
  message,
  confirmationButtonTitle,
  type = "error",
  }: ConfirmationModalProps) => {
  const classes = useStyles({type})();

  return (
    <RFModal
      open={open}
      boxProps={{ className: classes.container }}
      onClose={onClose}
    >
      <Grid
        container
        component="form"
        onSubmit={(e) => {
          e.preventDefault();
          e.stopPropagation();
          onConfirm();
        }}
        rowGap={theme.spacing(3)}
      >
        <Grid item xs={12}>
          <Typography variant="h5" fontSize={18}>
            {title}
          </Typography>
        </Grid>

        <Grid item xs={12}>
          <Typography variant="body1">{message}</Typography>
        </Grid>

        <Grid
          container
          item
          xs={12}
          justifyContent="space-between"
          marginTop={theme.spacing(2)}
        >
          <Grid item>
            <Button
              color="secondary"
              className={` ${classes.button} ${classes.backButton}`}
              onClick={onClose}
            >
              Cancel
            </Button>
          </Grid>

          <Grid item>
            <LoadingButton
              variant="contained"
              color="primary"
              className={classes.button}
              label={confirmationButtonTitle}
              onClick={onConfirm}
              loading={isLoading}
            />
          </Grid>
        </Grid>
      </Grid>
    </RFModal>
  );
};

export default ConfirmationModal;
